<ng-container>
    <div class="ppl-container-body">
        <div class="ppl-container-head">
            <h1 class="page-title-accessibility" tabindex="-1" pplAutoFocusHeader>Payroll Adjustment</h1>
        </div>
        <div class="ppl-container">
            <div class="ppl-content-container">
                <div class="w-100">
                    <ppl-timesheet-filter [filterFields]="fields" [chequeNumbers]="chequeNumbers"
                        (searchEvent)="onSearch($event)"></ppl-timesheet-filter>
                    <p class="pl-2"> <span class="error-message1" [attr.aria-label]="'Required'">*</span> At least one out of the following fields
                        should be populated: <b>Consumer Name</b>, <b>Consumer PPL ID</b>, <b>Provider Name</b>,
                        <b>Provider PPL ID</b>.
                    </p>
                    <div>
                        <p><strong>Note:</strong></p>
                        <ul>
                            <li>For <strong>Adjust</strong> and <strong>Void</strong> actions, please select the
                                applicable timesheet.</li>
                            <li>The <strong>Adjust All</strong> and <strong>Void All</strong> actions will update all
                                timesheets that match the search criteria OR all the selected timesheets.</li>
                        </ul>
                    </div>
                </div>
                <div class="table-style">
                    @if(timesheets.length > 0) {
                    <ppl-list-table [cols]="cols" rowDataAccessibilityKey="tas_timesheetline_detail_id" [disableSort]="true" [disableSearch]="true" [showCustomSearch]="false"
                        [data]="timesheets" [customDataLoaded]="true" [enableActions]="false" [from]="'timesheet'"
                        [gridTitle]="false" [pagination]="true" [loadPage]="true" [actionButtons]="actionButtons"
                        [enablePageActions]="true" [timesheetFor]="'pendedTimesheet'" [listButton]="buttons"
                        (actionInvoked)="gridAction($event)">
                    </ppl-list-table>
                    } @else {
                    <div class="alert alert-warning"><strong>No Records Found. </strong>Please change the filters to
                        find the records</div>
                    }
                </div>
            </div>
        </div>
    </div>
</ng-container>

<div class="filter-panel">
    <ng-template #timesheetAdjustVoidDialog let-cancel="cancel">
        <ppl-timesheet-adjust-void-entry [timesheetData]="timesheetData" [searchParams]="appliedFilters"
            [actionData]="selectedAction" (timesheetAdjustedOrVoided)="timesheetAdjustedOrVoided($event)"
            [source]="'payroll'"></ppl-timesheet-adjust-void-entry>
    </ng-template>
</div>

<div class="filter-panel">
    <ng-template #searchFilterWarningDialog let-cancel="cancel">
        <p> At least one out of the following fields should be populated: Consumer Name, Consumer PPL ID, Provider Name,
            Provider PPL ID</p>
    </ng-template>
</div>